import Ajv from "ajv";

import { lvtResponseSchema } from "@/api/common";


const liveUnitProperties = {
    clientId: { type: "number" },
    clientName: { type: "string" },
    dateActivated: { type: ["string", "null"] },
    dateDeactivated: { type: ["string", "null"] },
    id: { type: "integer" },
    latitude: { type: ["number", "null"] },
    locationName: { type: "string" },
    longitude: { type: ["number", "null"] },
    mountingStructure: { type: ["string", "null"] },
    name: { type: "string" },
    regionName: { type: ["string", "null"] },
    serial: { type: ["string", "null"] },
};

const liveUnitsSchema = lvtResponseSchema({
    type: "array",
    items: {
        type: "object",
        properties: liveUnitProperties,
    },
});

export const liveUnitsValidator = new Ajv().compile(liveUnitsSchema);
